'use client'

import clsx from 'clsx'
import { useCookieConsent } from 'components/CookieConsent'
import ChevronDown from 'public/assets/chevron-down-gray.svg'
import { createContext, ReactNode, useContext, useEffect, useRef, useState } from 'react'
import styles from './Footer.module.scss'

const LegalContext = createContext<{ open: boolean; toggle: () => void }>({ open: false, toggle: () => undefined })

export const FooterLegalProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false)

  return <LegalContext.Provider value={{ open, toggle: () => setOpen((o) => !o) }}>{children}</LegalContext.Provider>
}

export const FooterLegalToggle = () => {
  const { open, toggle } = useContext(LegalContext)

  return (
    <div className={styles.link} onClick={toggle}>
      Legal Information
      <span />
      <ChevronDown className={clsx(styles.chevron, !open ? styles.down : styles.up)} />
    </div>
  )
}

export const FooterLegalPanel = ({ children }: { children: ReactNode }) => {
  const { open } = useContext(LegalContext)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (open) {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [open])

  return (
    <div ref={ref} className={clsx(styles.legal, open && styles.open)}>
      {children}
    </div>
  )
}

export const CookieSettingsButton = () => {
  const { openSettings } = useCookieConsent()

  return (
    <button type='button' className={styles.link} onClick={openSettings} aria-label='Open cookie settings'>
      Cookie Settings
      <span />
    </button>
  )
}
